/* projects/shared/nvps-libraries/design/nv-box/nv-box.component.scss */
nv-box div {
  display: flex;
  box-sizing: border-box;
  background: var(--color-white);
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  height: var(--space-xxl);
  border: 1px solid var(--color-grey-light-8);
  border-radius: 8px;
}
nv-box div span {
  padding: 0px 0px 0px var(--space-m);
  font-size: 16px;
  letter-spacing: 0.0192em;
  line-height: 145%;
  font-family: var(--font-family-normal);
  font-style: normal;
  font-weight: 400;
  font-family: "NvLatoSemibold";
  font-weight: 600;
  text-transform: none;
  color: var(--color-blue);
  max-width: 222px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
nv-box div nv-icon {
  padding: 0px var(--space-s);
}
nv-box div.box-disabled {
  opacity: 0.7;
  pointer-events: none;
}
nv-box div.box-disabled span {
  opacity: 0.7;
  color: var(--color-primary-text-disabled);
}
nv-box {
  display: inline-block;
}
/*# sourceMappingURL=nv-box.component-IUPXE7LE.css.map */
